import { useEffect, useState } from "react";
import { Gift, Tag, X } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg, inr } from "@/lib/api";

export const REF_KEY = "cpd_ref";

export default function PromoCode({ amount, promo, onChange }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async (c = code, silent = false) => {
    if (!c.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/promos/validate", { code: c.trim(), amount });
      onChange(data);
      toast.success(`${data.code} applied — you save ${inr(data.discount)}`);
    } catch (err) {
      if (silent) localStorage.removeItem(REF_KEY); else toast.error(errMsg(err));
    }
    setBusy(false);
  };

  useEffect(() => {
    const ref = localStorage.getItem(REF_KEY);
    if (ref && !promo && amount) apply(ref, true);
  }, [amount]); // eslint-disable-line react-hooks/exhaustive-deps

  if (promo) {
    const I = promo.referral ? Gift : Tag;
    return (
      <div className="flex items-center justify-between rounded-lg border border-[#789A82]/40 bg-[#F0F5F1] px-3 py-2 text-sm" data-testid="promo-applied">
        <span className="flex items-center gap-2 text-[#4F7A5C]"><I className="h-4 w-4" /><strong>{promo.code}</strong> · {promo.label} · −{inr(promo.discount)}</span>
        <button type="button" data-testid="promo-remove-btn" onClick={() => { onChange(null); setCode(""); }} className="rounded-full p-1 text-[#8C8498] hover:text-[#26232E]" aria-label="Remove promo"><X className="h-4 w-4" /></button>
      </div>
    );
  }
  return (
    <div className="flex gap-2">
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Promo or referral code" data-testid="promo-code-input" className="h-10 bg-white uppercase"
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }} />
      <button type="button" data-testid="promo-apply-btn" disabled={busy || !code.trim()} onClick={() => apply()} className="btn-ghost !h-10 !px-4 !py-0 text-sm">Apply</button>
    </div>
  );
}

export function useCredit(subtotal) {
  const [credit, setCredit] = useState(0);
  useEffect(() => { api.get("/referral").then((r) => setCredit(r.data.credit || 0)).catch(() => {}); }, []);
  return Math.max(0, Math.min(credit, subtotal - 1));
}
